// extracted by mini-css-extract-plugin
export default {"profileCard":"profileCard_profileCard__n-a40","profileCardvalue":"profileCard_profileCardvalue__4MjE9","logoutbtn":"profileCard_logoutbtn__t8d41"};